import { getSupabase } from '@trader-dashboard/database';
/**
 * Analysis reads are served by Postgres functions rather than by pulling the
 * order table to the client: the largest account already holds several
 * thousand orders, and the day-by-pair rollup is far cheaper next to the data.
 */
export class AnalysisApiService {
    async getPairAnalysis(accountId, metric, range, timezone) {
        const supabase = getSupabase();
        // @ts-ignore - RPC function exists but types not generated due to SECURITY DEFINER
        const { data, error } = await supabase.rpc('get_pair_analysis', {
            p_account_id: accountId,
            p_metric: metric,
            p_start: range.start ?? null,
            p_end: range.end ?? null,
            p_timezone: timezone,
        });
        if (error) {
            console.error('AnalysisApi.getPairAnalysis error:', error);
            throw new Error(error.message || 'Failed to load pair analysis');
        }
        const parsed = typeof data === 'string' ? JSON.parse(data) : data;
        return (parsed ?? { points: [], pairs: [] });
    }
    async getDrawdownInputs(accountId) {
        const supabase = getSupabase();
        // @ts-ignore - RPC function exists but types not generated due to SECURITY DEFINER
        const { data, error } = await supabase.rpc('get_drawdown_inputs', {
            p_account_id: accountId,
        });
        if (error) {
            console.error('AnalysisApi.getDrawdownInputs error:', error);
            throw new Error(error.message || 'Failed to load drawdown inputs');
        }
        const parsed = typeof data === 'string' ? JSON.parse(data) : data;
        return (parsed ?? { openOrders: [], valueFactors: [] });
    }
}
export const analysisApi = new AnalysisApiService();
/** Time frames resolve to a fixed window, so responses are safe to cache. */
export const pairAnalysisCacheKey = (accountId, metric, timeFrame, range) => `${accountId}|${metric}|${timeFrame}|${range.start ?? ''}|${range.end ?? ''}`;
